import { render, staticRenderFns } from "./PayMatchingOrder.vue?vue&type=template&id=66e0461e&scoped=true"
import script from "./PayMatchingOrder.vue?vue&type=script&lang=js"
export * from "./PayMatchingOrder.vue?vue&type=script&lang=js"
import style0 from "./PayMatchingOrder.vue?vue&type=style&index=0&id=66e0461e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e0461e",
  null
  
)

export default component.exports